import React from 'react';
import { useSelector } from 'react-redux';
import {
  FormControl,
  Grid,
  TextField,
} from '@material-ui/core';
import { calculateSavings } from 'pages/quotes/helpers';


const QuoteItemQuantity = ({
  item,
  index,
  formik,
  selectedDataSource
}) => {
  const {
    customerPushCart,
    quoteProductsByGroup
  } = useSelector((state: IReduxState) => state.quote);

  const {
    touched,
    errors,
    handleChange,
    handleBlur,
    setFieldValue
  } = formik;

  const {
    selectedItemGroup,
    sku,
    discountType,
    discount,
    fixedPrice,
  } = item;

  const selectedItem = quoteProductsByGroup?.[selectedItemGroup]?.find((product) => product.sku == item?.sku || null);

  const {
    productAttributes,
  } = selectedDataSource;

  const savings = +productAttributes?.savings || 0;
  const isAlleSku = sku.includes('bdsku');

  const {
    type_id,
    extension_attributes = {},
  } = selectedItem || {};

  const { stock_item } = extension_attributes;
  const qtyLimit: IQtyLimit = { min: 1 };
  const isSimple = type_id === 'simple';

  const productItemsInCustomerPushCart =
    customerPushCart?.selectedItems.reduce((qty, item) => {
      if (item.sku === sku) {
        qty += item.qty;
      }

      return qty;
    }, 0);

  if (isSimple && stock_item.qty && stock_item.qty > 0) {
    qtyLimit.max = productItemsInCustomerPushCart ? stock_item.qty - productItemsInCustomerPushCart : stock_item.qty;
  }

  const handleQuantityChange = (event) => {
    handleChange(event);
    const { value } = event.target;

    const updatedValues = {
      qty: value,
      savings: calculateSavings(discountType, discount, fixedPrice, savings, value),
    };

    setFieldValue(`items[${index}]`, { ...item, ...updatedValues });
  };

  return (
    <Grid item xs={12} lg={1}>
      <FormControl variant="outlined" fullWidth>
        <TextField
          name={`items[${index}].qty`}
          label="Qty"
          fullWidth
          type="number"
          disabled={!selectedItemGroup || !sku || isAlleSku}
          inputProps={!productItemsInCustomerPushCart && qtyLimit}
          variant="outlined"
          value={item.qty}
          onChange={handleQuantityChange}
          onBlur={handleBlur}
          error={touched.items?.[index]?.qty && !!errors.items?.[index]?.qty}
          helperText={touched.items?.[index]?.qty && errors.items?.[index]?.qty}
        />
      </FormControl>
    </Grid>
  );
};

export default QuoteItemQuantity;
